import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js'
import { MeshoptDecoder } from 'three/addons/libs/meshopt_decoder.module.js'

/** glTF 用 Draco 解码器目录（由 Vite 从 `three` 同步至 `public/draco/gltf/`） */
const DRACO_DECODER_PATH = `${import.meta.env.BASE_URL}draco/gltf/`

let sharedDracoLoader: DRACOLoader | null = null

function getSharedDracoLoader(): DRACOLoader {
  if (!sharedDracoLoader) {
    sharedDracoLoader = new DRACOLoader()
    sharedDracoLoader.setDecoderPath(DRACO_DECODER_PATH)
  }
  return sharedDracoLoader
}

/**
 * 创建已注入 Meshopt / Draco 解码器的 glTF 加载器（Draco 实例进程内复用）。
 */
export function createConfiguredGltfLoader(): GLTFLoader {
  const loader = new GLTFLoader()
  loader.setMeshoptDecoder(MeshoptDecoder)
  loader.setDRACOLoader(getSharedDracoLoader())
  return loader
}

/** 释放共享 Draco Worker（编辑器卸载时可选调用） */
export function disposeSharedGltfDecoders(): void {
  sharedDracoLoader?.dispose()
  sharedDracoLoader = null
}
